import styled from 'styled-components';
import { targetable } from '../Card/styled';
import { WIDE_SCREEN } from '../ActiveGame/styled';

export const Label = styled.div`
  padding: 8px 12px 0;
  font-size: 11px;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--muted);
`;

/** One scrolling row when the phone is upright; wrapped rows in the side panel when it is turned. */
export const Tray = styled.div`
  --card-w: 64px;
  display: flex;
  gap: 6px;
  padding: 8px 12px 12px;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  border-radius: 8px;
  ${props => props.$lit && targetable}

  @media (orientation: landscape) {
    --card-w: 58px;
    flex-wrap: wrap;
    overflow-x: visible;
  }

  @media ${WIDE_SCREEN} {
    --card-w: clamp(72px, 6.5vw, 110px);
    gap: 8px;
  }
`;
